import React from 'react';
import BootstrapOffcanvas from 'react-bootstrap/Offcanvas';
import { useDialogs } from '../../hooks';
import Component, { Content } from './Component';

export const OffcanvasCompiler = ({ content, ...props }) => {
  return (
    <Offcanvas {...props}>
      <Content content={content} />
    </Offcanvas>
  );
};

export const Offcanvas = ({ children, ...props }) => {
  const { dialogs = {}, hide } = useDialogs();
  const { [props.id]: dialog = {} } = dialogs;
  const { isShown = false } = dialog;

  const handleHide = () => {
    hide(props.id);
  };

  return (
    <Component
      {...props}
      show={isShown}
      onHide={handleHide}
      component={BootstrapOffcanvas}
    >
      {children}
    </Component>
  );
};

Offcanvas.Body = BootstrapOffcanvas.Body;
Offcanvas.Header = BootstrapOffcanvas.Header;
Offcanvas.Title = BootstrapOffcanvas.Title;

Offcanvas.displayName = 'Offcanvas';
OffcanvasCompiler.displayName = 'Offcanvas';
export default OffcanvasCompiler;
